<template>
    <div>
        <div class="compositions-container">
            <compositions-icon class="compositions-container__icon">
            </compositions-icon>
            <div class="compositions-container__title">
                Compositions
            </div>
            <div class="compositions-table">
                <Table
                    :columns="['Compositions name', 'Number of Downloads']"
                    :data="
                        getCompositions && getCompositions.length > 0
                            ? getCompositions.slice(0, 3)
                            : null
                    "
                    :cell-style="
                        'display: grid; grid-template-columns: 20fr 15rem; grid-template-rows: auto;'
                    "
                    :data-elements="
                        getCompositions ? ['name', 'downloads'] : null
                    "
                    :footer-elements="
                        getCompositions && getCompositions.length > 0
                            ? [
                                  'Total',
                                  `${totalNumber(
                                      getCompositions,
                                      'downloads'
                                  )}`,
                              ]
                            : null
                    "
                    :footer-style="'height: 66px;'"
                    :is-loading="getLoading"
                    :no-title="true"
                />
            </div>
        </div>

        <button-default
            class="compositions-container__view-all"
            :color="'veryDarkBlue'"
            :style="veryDarkBlueButton"
            :link="ALL_COMPOSITIONS_PAGE_NAME"
            :component-nav="true"
            :svg="true"
            :text="'View All'"
            :name="'view_all_arrow'"
            :svg-style="'width: 12px; fill: white; margin: auto 2px;'"
        />
    </div>
</template>

<script>
import { ALL_COMPOSITIONS_PAGE_NAME } from '@/router/pageNameConstants.js';

import { totalNumber } from '@/lib/calculations.js';
import CompositionsIcon from 'Svgs/puzzle-icon.svg?inline';
import { mapGetters } from 'vuex';
import Button from '@/components/common/Button';
import LoadingTable from '@/components/common/loading/LoadingTable';
import Table from '@/components/common/Table.vue';

export default {
    name: 'Compositions',
    components: {
        CompositionsIcon,
        'button-default': Button,
        LoadingTable,
        Table,
    },
    data() {
        return {
            ALL_COMPOSITIONS_PAGE_NAME,
            total_number_of_downloads: null,
            veryDarkBlueButton: {
                width: '94px',
                height: '29px',
                fontFamily: '$palanquin-font',
                fontSize: '13px',
                fontWeight: '400',
                letterSpacing: '0.05px',
                margin: '2rem 5rem auto auto',
            },
        };
    },
    computed: {
        ...mapGetters('all_assets', {
            getCompositions: 'getCompositions',
            getLoading: 'getLoading',
        }),
    },
    methods: {
        totalNumber,
    },
};
</script>

<style scoped lang="scss">
.compositions-container {
    display: grid;
    grid-template-columns: 4rem 20fr;
    grid-template-rows: 3rem auto;
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        grid-template-columns: 1fr 2fr;
    }
    &__icon {
        margin: 6px auto auto 3.1rem;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-row: 1;
            grid-column: 1;
            margin: 6px auto auto 1.1rem;
        }
    }
    &__title {
        margin: -0.5rem auto auto 1rem;
        width: 261px;
        height: 29px;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 28px;
        font-weight: 700;
        letter-spacing: 0.44px;
        line-height: 53px;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 220px;
            grid-row: 1;
            grid-column: 1;
            margin: -0.5rem auto auto 3rem;
        }
    }
}
.compositions-table {
    grid-column: 1 / 3;
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        grid-row: 2;
        grid-column: 1 / 3;
        width: 90%;
        position: static;
        margin: 0 auto auto 1rem;
        bottom: 0;
        right: 0;
    }
    &__head-row {
        display: grid;
        grid-template-columns: 8fr 3fr 1fr;
        grid-template-rows: 4rem;
        width: 90%;
        height: 66px;
        border-radius: 6px 6px 0 0;
        background-color: #dce3e9;
        margin: 0 auto auto 3rem;

        @media (min-width: $xs-up) and (max-width: $lg-up) {
            width: 90%;
            height: 88px;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-template-columns: 7fr 3fr 1fr;
            margin: 0 auto auto 0;
            width: 450px;
            height: 90px;
        }

        h3 {
            margin: auto auto auto 1rem;
            width: auto;
            height: 30px;
            color: $blue-main;
            font-family: $istok-font;
            font-size: 22px;
            font-weight: 700;
            letter-spacing: 0.18px;
            line-height: 30px;
        }
    }

    &__data {
        display: grid;
        grid-template-columns: 8fr 3fr 1fr;
        grid-template-rows: 4rem;
        width: 90%;
        height: 58px;
        background-color: rgba(244, 245, 246, 0.15);
        margin: 0 auto auto 3rem;
        border-bottom: 1px solid #e0e0e0;

        @media (min-width: $xs-up) and (max-width: $lg-up) {
            width: 90%;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 0 auto auto 0;
            width: 450px;
        }

        p {
            margin: auto auto auto 1rem;
            width: auto;
            color: $blue-main;
            font-family: $istok-font;
            font-size: 22px;
            font-weight: 400;
            letter-spacing: 0.18px;
            line-height: 30px;
        }
    }
    &__foot {
        display: grid;
        grid-template-columns: 8fr 3fr 1fr;
        grid-template-rows: 4rem;
        width: 90%;
        height: 66px;
        margin: 0 auto auto 3rem;
        border-radius: 0 0 6px 6px;
        background-color: rgba(244, 245, 246, 0.6);

        @media (min-width: $xs-up) and (max-width: $lg-up) {
            width: 90%;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 0 auto auto 0;
            width: 450px;
        }

        h3 {
            margin: auto auto auto 1rem;
            width: auto;
            height: 30px;
            color: $blue-main;
            font-family: $istok-font;
            font-size: 22px;
            font-weight: 700;
            letter-spacing: 0.18px;
            line-height: 30px;
        }
    }
    &__view-all {
        margin-right: 3rem;
        @media (max-width: $xl-up) {
            margin-right: -6rem;
        }
    }
}
</style>
<style lang="scss">
.compositions-table {
    margin: 1rem auto auto 3rem;
    width: 90%;

    @media (max-width: $xs-up) {
        margin: auto;
        width: 90%;
    }
    .generic-table {
        .cont {
            @media (max-width: $xs-up) {
                width: 600px;
            }
        }

        .rowCell {
            @media (max-width: $xs-up) {
                min-width: 100px;
            }
        }
    }
}
</style>
